
define('tpl!taoQtiItem/qtiCreator/tpl/forms/static/text', ['handlebars'], function(hb){ 
return hb.template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression;


  buffer += "<div class=\"panel\">\n    <em>"
    + escapeExpression((helper = helpers.__ || (depth0 && depth0.__),options={hash:{},data:data},helper ? helper.call(depth0, "no configuration property needed", options) : helperMissing.call(depth0, "__", "no configuration property needed", options)))
    + "</em>\n</div>\n";
  return buffer;
  });
});

